<script lang="ts">
	import { onDestroy, onMount } from "svelte";
	import { yyyy, zzzz } from "../../../store.svelte";
	import EnergyBalanceUpload from "./EnergyBalanceUpload.svelte";

	let {
		expanded = $bindable(),
		control = $bindable(),
		menuActive = $bindable(),
	} = $props();

	let analysisName: string = $state("");

	onMount(() => {
		zzzz.emit("EnergyBalance");
	});

	onDestroy(() => {
		zzzz.emit("clearEnergyBalance");
		zzzz.emit("end Energy Balance");
	});
</script>

<div id="energy-balance" class="card-content">
	<div class="content">
		<h4 class="info-title">Energy Balance</h4>

		<div class="form-section">
			<label class="field-label" for="analysis-name">Analysis Name</label>
			<input
				id="analysis-name"
				type="text"
				class="input-field"
				bind:value={analysisName}
				placeholder="Enter analysis name (5-50 characters)..."
				minlength="5"
				maxlength="50"
			/>
		</div>

		<EnergyBalanceUpload {analysisName} />
	</div>
</div>

<style>
	#energy-balance {
		width: 100%;
		padding: 8.775px;
		overflow-y: auto;
	}

	.info-title {
		text-align: center;
		margin-bottom: 1rem;
	}

	.form-section {
		margin-bottom: 1rem;
	}

	.field-label {
		display: block;
		font-weight: 500;
		font-size: 0.9rem;
		color: #4a5568;
		margin-bottom: 0.5rem;
	}

	.input-field {
		width: 100%;
		padding: 0.5rem 0.75rem;
		border: 1px solid #dbdbdb;
		border-radius: 4px;
		font-size: 0.9rem;
		transition: border-color 0.2s;
	}

	.input-field:focus {
		outline: none;
		border-color: #ff3e00;
		box-shadow: 0 0 0 2px rgba(255, 62, 0, 0.1);
	}

	.input-field::placeholder {
		color: #a0aec0;
	}
</style>
